import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { formatDateTime } from '../../../common/utils/helpers';
import Form from 'antd/lib/form';
import { messageStatus, messageStatusT } from '../../../common/enums'
import { OpenFileLink } from '../../../common/components/data-display';
import { Button } from 'antd/lib/radio';


const formItemLayout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 14 },
};


const getAttachments = (attachments, token) => {

  let fileLinks = attachments.map(attachment =>
    <div>
      <OpenFileLink href={`${process.env.REACT_APP_API_URL}/file/${attachment.file.id}?token=${token}`}>
        {attachment.file.name}
      </OpenFileLink>
    </div>
  )
  return fileLinks
}
@translate()
export default class EmailLogDetail extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    token: PropTypes.string.isRequired,
    emailLog: PropTypes.object.isRequired
  };


  render() {
    const {
      emailLog,
      token,
      t,
    } = this.props;

    return (

      <div>
        <h2>{t('Detail e-mailovej správy')}</h2>

        <Button onClick={() => { window.location.href = `?tab=3#/admin/messaging` }} >{t("Späť na zoznam e-mailov")}</Button>


        <Form>
          <Form.Item {...formItemLayout} label={t('ID správy')}>
            <span>{emailLog.id}</span>
          </Form.Item>

          <Form.Item {...formItemLayout} label={t('Stav')}>
            <span>{messageStatusT[messageStatus[emailLog.status]]}</span>
          </Form.Item>

          <Form.Item {...formItemLayout} label={t('Dátum zaslania')}>
            <span>{emailLog.sentDate ? formatDateTime(emailLog.sentDate) : ''}</span>
          </Form.Item>

          <Form.Item {...formItemLayout} label={t('Prijímateľ')}>
            <span>{emailLog.receiverNameFirst + " " + emailLog.receiverNameLast}</span>
          </Form.Item>

          <Form.Item {...formItemLayout} label={t('E-mailová adresa')}>
            <span>{emailLog.receiver}</span>
          </Form.Item>

          <Form.Item {...formItemLayout} label={t('Predmet správy')}>
            <span>{emailLog.subject}</span>
          </Form.Item>

          <Form.Item {...formItemLayout} label={t('Správa prečítaná')}>
            <span>{emailLog.read ? t("Áno") : t("Nie")}</span>
          </Form.Item>

          <Form.Item {...formItemLayout} label={t('Náhľad správy')}>
            {emailLog.message.trim().length > 0 ?
              <span> <iframe className="email-log-iframe" srcDoc={emailLog.message.replace("/api/track/", "disableTracking")}>
              </iframe></span> :
              <span>{t("Správa je prázdna")}</span>}
          </Form.Item>

          <Form.Item {...formItemLayout} label={t('Prílohy')}>
            {emailLog.attachments.attachments.length > 0 ?
              getAttachments(emailLog.attachments.attachments, token) :
              <span>{t("Správa neobsahuje žiadne prílohy")}</span>
            }

          </Form.Item>
        </Form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/messaging-dashboard/components/EmailLogDetail.js